module.exports = __webpack_public_path__ + "static/bg5.454dcc6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg5.png
// module id = 488
// module chunks = 195485404593854